var v1="<div gnp-basic-analysis=\"\" basic-analysis-data=\"basicAnalysisCtrl.basicAnalysisData\" class=\"score-circle-charts-wrap\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/basic-analysis/basic-analysis.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/analysis/basic-analysis/basic-analysis.jade
// module id = 454
// module chunks = 0